import { render, staticRenderFns } from "./NoticiasMercadoTopBanner.vue?vue&type=template&id=3a866e0a&"
import script from "./NoticiasMercadoTopBanner.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoTopBanner.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasMercadoTopBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports